import { getCgiDefaultParamsValue } from "../../../common/schemaUtil";
import { FORM_METHOD_TYPES } from "../../../stateCommon/consts";
import { getObjectJSONString } from "../../utils/code";
import { METHOD_TEMPLATES } from "../../utils/consts";
export const custom = options => {
  const {
    cgi
  } = options;
  const res = getCgiDefaultParamsValue(options.collection, cgi);
  const code = getObjectJSONString(res);
  const info = {
    args: [],
    type: FORM_METHOD_TYPES.request,
    tpl: METHOD_TEMPLATES.custom,
    cgi: cgi,
    params: {
      request: code,
      skipCode: true
    }
  };
  return info;
};
//# sourceMappingURL=custom.js.map
